import Vue from 'vue';
import buttonComponent from './button.vue';
import progressBar from './progressBar.vue';
import paginataion from './pagination.vue';
import checkbox from './checkbox.vue';
import radio from './radio.vue';
import wheelSelector from './wheelSelector.vue';
import input from './input.vue';
import successModal from './successModal.vue';
import bottomSheet from './bottomSheet.vue';
import tagInput from './tagInput.vue';
import LoaderComponent from './loader.vue';
import ModalComponent from './modal.vue';
import Battery from './battery.vue';

Vue.component('ButtonComponent', buttonComponent);
Vue.component('ProgressBar', progressBar);
Vue.component('PaginationComponent', paginataion);
Vue.component('CheckBox', checkbox);
Vue.component('RadioComponent', radio);
Vue.component('WheelSelector', wheelSelector);
Vue.component('InputComponent', input);
Vue.component('SuccessModal', successModal);
Vue.component('BottomSheet', bottomSheet);
Vue.component('TagInput', tagInput);
Vue.component('LoaderComponent', LoaderComponent);
Vue.component('ModalComponent', ModalComponent);
Vue.component('BatteryComponent', Battery);
